if (typeof hlfCardInitialized === 'undefined') {
  document.addEventListener('click', function (e) {
    // Add to Cart Logic
    const cartBtn = e.target.closest('[data-add-to-cart]');
    if (cartBtn && !cartBtn.disabled) {
      e.preventDefault();
      const variantId = cartBtn.dataset.variantId;
      if (!variantId) return;

      cartBtn.classList.add('is-loading');
      cartBtn.disabled = true;

      // Mirror Dawn's product-form.js exactly
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      if (cart) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(cartBtn);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error('Cart Error:', response.description);
            return;
          } else if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          });

          cart.renderContents(response);

          const text = cartBtn.querySelector('.hlf-btn-text');
          if (text) {
            const original = text.textContent;
            text.textContent = '✓ Added!';
            setTimeout(() => { text.textContent = original; }, 2000);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          cartBtn.classList.remove('is-loading');
          cartBtn.disabled = false;
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
    }

    // Wishlist Logic
    const wishBtn = e.target.closest('[data-wishlist-btn]');
    if (wishBtn) {
      e.preventDefault();
      wishBtn.classList.toggle('is-wishlisted');
      const productId = wishBtn.dataset.productId;
      document.dispatchEvent(new CustomEvent('hlf:wishlist:toggle', {
        detail: { productId, isWishlisted: wishBtn.classList.contains('is-wishlisted') }
      }));
    }

    // ── Helper to close modal & unlock scroll ──
    function closeHlfModal(activeModal) {
      if (activeModal) {
        activeModal.classList.remove('is-open');
        document.body.classList.remove('hlf-modal-open');
        document.body.style.overflow = '';
      }
    }

    // ── Variant Modal Sheet Open Handler ──
    const trigger = e.target.closest('[data-open-variant-modal]');
    if (trigger) {
      e.preventDefault();
      const productId = trigger.dataset.openVariantModal;
      const card = trigger.closest('.hlf-product-card');
      let modal = card ? card.querySelector('.hlf-variant-modal-backdrop') : null;
      if (!modal) {
        modal = document.getElementById('HlfVariantModal-' + productId);
      }
      if (modal) {
        if (card) modal._originCard = card;
        // Teleport modal to document.body so position:fixed spans viewport instead of card
        if (modal.parentNode !== document.body) {
          document.body.appendChild(modal);
        }
        requestAnimationFrame(() => {
          modal.classList.add('is-open');
          document.body.classList.add('hlf-modal-open');
          document.body.style.overflow = 'hidden';
        });
      }
    }

    // ── Variant Modal Sheet Close Handler ──
    const closeBtn = e.target.closest('[data-close-variant-modal]');
    const backdrop = e.target.closest('.hlf-variant-modal-backdrop');
    if (closeBtn || (backdrop && e.target === backdrop)) {
      const activeModal = document.querySelector('.hlf-variant-modal-backdrop.is-open');
      closeHlfModal(activeModal);
    }

    // ── Variant Option Pill Selection inside Modal ──
    const pillBtn = e.target.closest('.hlf-variant-pill-btn');
    if (pillBtn) {
      e.preventDefault();
      const group = pillBtn.closest('.hlf-variant-option-group');
      const modal = pillBtn.closest('.hlf-variant-modal-backdrop');
      if (!group || !modal) return;

      // Toggle active pill state in group
      group.querySelectorAll('.hlf-variant-pill-btn').forEach(b => b.classList.remove('is-selected'));
      pillBtn.classList.add('is-selected');

      // Update selected value display header
      const optIdx = pillBtn.dataset.optionIdx;
      const optVal = pillBtn.dataset.optionVal;
      const displayLabel = group.querySelector('[data-opt-selected-display]');
      if (displayLabel) displayLabel.textContent = optVal;

      // Collect all selected values from all groups
      const selectedValues = Array.from(modal.querySelectorAll('.hlf-variant-option-group')).map(g => {
        const selectedPill = g.querySelector('.hlf-variant-pill-btn.is-selected');
        return selectedPill ? selectedPill.dataset.optionVal : null;
      });

      // Parse JSON variants
      const jsonScript = modal.querySelector('.hlf-variant-modal-json');
      if (!jsonScript) return;
      try {
        const variants = JSON.parse(jsonScript.textContent);
        const matchedVariant = variants.find(v => {
          return (
            (!selectedValues[0] || v.option1 === selectedValues[0]) &&
            (!selectedValues[1] || v.option2 === selectedValues[1]) &&
            (!selectedValues[2] || v.option3 === selectedValues[2])
          );
        });

        if (matchedVariant) {
          // Update Modal Image
          if (matchedVariant.featured_image) {
            const modalImg = modal.querySelector('[data-modal-variant-img]');
            if (modalImg) modalImg.src = matchedVariant.featured_image;
          }

          // Update Modal Prices & Discount Tag
          const modalPrice = modal.querySelector('[data-modal-price]');
          const modalCtaPrice = modal.querySelector('[data-modal-cta-price]');
          if (modalPrice) modalPrice.innerHTML = matchedVariant.price_formatted;
          if (modalCtaPrice) modalCtaPrice.innerHTML = matchedVariant.price_formatted;

          const modalCompare = modal.querySelector('[data-modal-compare]');
          const modalCtaCompare = modal.querySelector('[data-modal-cta-compare]');
          const modalDiscount = modal.querySelector('[data-modal-discount]');
          const modalSaveBadge = modal.querySelector('[data-modal-save-badge]');
          const modalSaveAmount = modal.querySelector('[data-modal-save-amount]');

          if (matchedVariant.compare_at_price > matchedVariant.price) {
            if (modalCompare) {
              modalCompare.innerHTML = matchedVariant.compare_at_price_formatted;
              modalCompare.style.display = '';
            }
            if (modalCtaCompare) {
              modalCtaCompare.innerHTML = matchedVariant.compare_at_price_formatted;
              modalCtaCompare.style.display = '';
            }
            const discPct = Math.round(((matchedVariant.compare_at_price - matchedVariant.price) * 100) / matchedVariant.compare_at_price);
            if (modalDiscount) {
              modalDiscount.innerHTML = `<span class="hlf-badge-diya">&#x1FA94;</span> ${discPct}% OFF`;
              modalDiscount.style.display = '';
            }
            if (modalSaveBadge && modalSaveAmount) {
              const saveCents = matchedVariant.compare_at_price - matchedVariant.price;
              const saveRupees = Math.round(saveCents / 100);
              modalSaveAmount.textContent = '\u20B9' + saveRupees.toLocaleString('en-IN');
              modalSaveBadge.style.display = 'flex';
            }
          } else {
            if (modalCompare) modalCompare.style.display = 'none';
            if (modalCtaCompare) modalCtaCompare.style.display = 'none';
            if (modalDiscount) modalDiscount.style.display = 'none';
            if (modalSaveBadge) modalSaveBadge.style.display = 'none';
          }

          // Update CTA Button State & Variant ID
          const modalCtaBtn = modal.querySelector('[data-modal-add-to-cart]');
          const modalCtaText = modal.querySelector('.hlf-modal-cta-text');
          if (modalCtaBtn) {
            modalCtaBtn.dataset.variantId = matchedVariant.id;
            if (matchedVariant.available) {
              modalCtaBtn.disabled = false;
              if (modalCtaText) modalCtaText.textContent = 'ADD TO CART';
            } else {
              modalCtaBtn.disabled = true;
              if (modalCtaText) modalCtaText.textContent = 'SOLD OUT';
            }
          }

          // Also update parent Product Card trigger pill text, prices & main card add-to-cart variant ID
          const modalId = modal.id.replace('HlfVariantModal-', '');
          const card = modal._originCard || document.querySelector(`.hlf-product-card[data-product-id="${modalId}"]`);
          const triggerText = card ? card.querySelector('[data-variant-trigger-text]') : null;
          if (triggerText) triggerText.textContent = matchedVariant.title;

          const cardAddBtn = card ? card.querySelector('[data-add-to-cart]') : null;
          if (cardAddBtn) cardAddBtn.dataset.variantId = matchedVariant.id;

          const cardPrice = card ? card.querySelector('.hlf-price--sale') : null;
          const cardOldPrice = card ? card.querySelector('[data-card-old-price]') : null;
          const modalOldPrice = modal.querySelector('[data-modal-old-price]');
          const cardCompare = card ? card.querySelector('.hlf-price--compare') : null;
          const cardDiscount = card ? card.querySelector('.hlf-discount-badge') : null;
          const cardSaveBadge = card ? card.querySelector('[data-card-save-badge]') : null;
          const cardSaveAmount = card ? card.querySelector('[data-card-save-amount]') : null;

          if (matchedVariant.old_price_formatted && matchedVariant.old_price > matchedVariant.price) {
            if (cardOldPrice) {
              cardOldPrice.innerHTML = matchedVariant.old_price_formatted;
              cardOldPrice.style.display = '';
            }
            if (modalOldPrice) {
              modalOldPrice.innerHTML = matchedVariant.old_price_formatted;
              modalOldPrice.style.display = '';
            }
          } else {
            if (cardOldPrice) cardOldPrice.style.display = 'none';
            if (modalOldPrice) modalOldPrice.style.display = 'none';
          }

          if (cardPrice) cardPrice.innerHTML = matchedVariant.price_formatted;
          if (matchedVariant.compare_at_price > matchedVariant.price) {
            if (cardCompare) {
              cardCompare.innerHTML = matchedVariant.compare_at_price_formatted;
              cardCompare.style.display = '';
            }
            if (cardDiscount) {
              const discPct = Math.round(((matchedVariant.compare_at_price - matchedVariant.price) * 100) / matchedVariant.compare_at_price);
              cardDiscount.innerHTML = `<span class="hlf-badge-diya">&#x1FA94;</span> ${discPct}% OFF`;
              cardDiscount.style.display = '';
            }
            if (cardSaveBadge && cardSaveAmount) {
              const saveCents = matchedVariant.compare_at_price - matchedVariant.price;
              const saveRupees = Math.round(saveCents / 100);
              cardSaveAmount.textContent = '\u20B9' + saveRupees.toLocaleString('en-IN');
              cardSaveBadge.style.display = 'flex';
            }
          } else {
            if (cardCompare) cardCompare.style.display = 'none';
            if (cardDiscount) cardDiscount.style.display = 'none';
            if (cardSaveBadge) cardSaveBadge.style.display = 'none';
          }
        }
      } catch(err) {
        console.error('Variant JSON parse error:', err);
      }
    }

    // ── Variant Modal Add to Cart CTA Handler ──
    const modalCta = e.target.closest('[data-modal-add-to-cart]');
    if (modalCta && !modalCta.disabled) {
      e.preventDefault();
      const variantId = modalCta.dataset.variantId;
      if (!variantId) return;

      modalCta.disabled = true;
      const ctaText = modalCta.querySelector('.hlf-modal-cta-text');
      const origText = ctaText ? ctaText.textContent : 'ADD TO CART';
      if (ctaText) ctaText.textContent = 'ADDING...';

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(modalCta);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((res) => res.json())
        .then((res) => {
          if (res.status) {
            console.error('Cart error:', res.description);
            return;
          }
          if (cart) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId, cartData: res });
            cart.renderContents(res);
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          }
          if (ctaText) ctaText.textContent = '✓ ADDED!';
          setTimeout(() => {
            if (ctaText) ctaText.textContent = origText;
            const activeModal = modalCta.closest('.hlf-variant-modal-backdrop');
            closeHlfModal(activeModal);
          }, 600);
        })
        .catch((err) => console.error(err))
        .finally(() => {
          modalCta.disabled = false;
        });
    }
  });
  window.hlfCardInitialized = true;
}
